import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bullhorn",
  "use": "bullhorn-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"bullhorn\">\n    <defs>\n        <path id=\"bullhorn_a\" d=\"M4 8h2v6H4V8zm3 0l9-4v12l-9-4V8zm2 1.158V11l5 2V7L9 9.158z\" />\n    </defs>\n    <use fill=\"#FFFFFF\" fill-rule=\"nonzero\" xlink:href=\"#bullhorn_a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol